import { parseParam } from 'lib/utils';
import { useRouter } from 'next/router';

export const useCurrentCategory = () => {
  const router = useRouter();
  const currentCategory = parseParam(router.query.category);

  return currentCategory;
};
